<app-organizer-shared-layout-dashboard
  class="organizer-planning-page-planning"
  [fullWidth]="true"
  [hasFooter]="true"
>
  <h1 class="title-4 mb-4">{{ 'organizer_planning.title' | translate }}</h1>
  <app-organizer-shared-calendar
    [timeslots]="timeslots"
    (updateDateRange)="updateDateRange($event)"
  ></app-organizer-shared-calendar>
</app-organizer-shared-layout-dashboard>

<app-modal
  #welcomeModal
  [hasCloseButton]="false"
  (modalClose)="welcomeModal.hide()"
>
  <span modal-header class="organizer-planning-welcome-modal__header">
    <app-logo
      class="organizer-planning-welcome-modal__logo"
      [height]="logoHeight"
      [alt]="'a11y.organizer_planning.welcome_modal.logo' | translate"
    ></app-logo>

    {{ 'organizer_planning.welcome_modal.title' | translate }}
  </span>

  <p modal-content>
    {{ 'organizer_planning.welcome_modal.text' | translate }}
  </p>

  <div modal-footer class="organizer-planning-welcome-modal__footer">
    <a
      app-vtmn-play-button
      [routerLink]="'/organizer.activity-creation.welcome' | localize"
    >
      {{ 'organizer_planning.welcome_modal.new_activity_button' | translate }}
    </a>

    <button
      app-vtmn-play-button
      type="button"
      class="organizer-planning-welcome-modal__button"
      [type]="ctaButtonType.Button"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="welcomeModal.hide()"
    >
      {{ 'organizer_planning.welcome_modal.cancel_button' | translate }}
    </button>
  </div>
</app-modal>
